import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetMeetIntegration as GetMeetIntegrationQuery} from 'nutshell-graphql-types';

import GET_MEET_INTEGRATION from '../queries/get-meet-integration.graphql';

export const useGetMeetIntegration = () => {
    const {data, error, loading, refetch, startPolling, stopPolling} = useQuery<
        GetMeetIntegrationQuery,
        Record<any, any>
    >(GET_MEET_INTEGRATION, {
        fetchPolicy: 'cache-and-network',
    });

    const isLoading = loading && !data;
    const loggedInUser = data ? data.loggedInUser : null;

    return {
        googleMeetIntegration: loggedInUser && loggedInUser.googleMeetIntegration,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
        startPolling,
        stopPolling,
    };
};
